import * as API from '@/api';
import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';

//initial state
function initialState () {
  return {
    list: [],
    company: null,
    display_company_msg:true,
    gateways : []
  };
}
const state = initialState ();

// actions

const actions = {
  async list (context, payload) {
    var response = await API.company.list (payload);
    // set company in list
    context.commit ('set_list', {
      companies: response.companies,
    });
    return response;
  },

  async get (context, payload) {
    var response = await API.company.get (payload);
    return response.company;
  },

  async initByDomain(context, payload){
      //get company from API
      let response = await API.company.initByDomain (payload);
      var company = response.company;

      //Set company
      context.commit ('set_company', {
        company: company,
      });

      //apply custom properties if company had custom properties
      if (company.custom_properties) {
        context.dispatch (
          'app/setTheme',
          {
            company: company,
          },
          DEFINES.USE_ROOT
        );
      }
      return company;
  },

  async initializeCompany (context, payload) {
    //reset old company
    context.commit ('screening/reset', null, DEFINES.USE_ROOT);

    //get company from API
    let company = await context.dispatch ('get');

    //Set company
    context.commit ('set_company', {
      company: company,
    });
    //apply custom properties if company had custom properties
    if (company.custom_properties) {
      context.dispatch (
        'app/setTheme',
        {
          company: company,
        },
        DEFINES.USE_ROOT
      );
    }
    return company;
  },
  async resetCurrentCompany (context, payload) {
    //reset old company
    context.commit ('screening/reset', null, DEFINES.USE_ROOT);

    //Reset company
    context.commit ('reset_company');

    //Reset theme
    await context.dispatch ('app/resetTheme', null, DEFINES.USE_ROOT);

    //Reset pages
    await context.dispatch ('page/resetPage', null, DEFINES.USE_ROOT);
  },

  async listPaymentGateways(context, payload){
    //get company payment gateways from API
    let response = await API.company.listPaymentGateways (payload);

    context.commit ('set_gateways', {
      gateways: response.gateways,
    });
    return response
  },
}

//getters
const getters = {
  getField,
  getCurrentCompanyId: (state, getters, rootState) => {
    if (!state.company) {
      return null;
    }
    return state.company.id;
  },

  getCurrentCompanyLanguage: state => {
    //if language is not set return default language
    if (state.company && state.company.custom_properties) {
      return state.company.custom_properties.language;
    }
    return DEFINES.THEME.PLATFORM.LOCALE;
  },

  getNavigationParamOfCompany: (state, getters, rootState) => {
    if (!state.company) {
      return null;
    }

    //for company homepage use slug if exist
    let nav_params = state.company.slug;
    if (!nav_params) {
      nav_params = state.company.id;
    }
    return nav_params;
  },
  getSelectedCompanyTimezone (state, getters) {
    if (state.company && state.company.custom_properties) {
      return state.company.custom_properties.timezone;
    }
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.companies;
  },

  set_gateways (state, payload){
    state.gateways = payload.gateways;
  },

  set_company (state, payload) {
    state.company = payload.company;
  },

  reset_company (state, payload) {
    state.company = null;
  },

  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
